<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Log')"
    width="700px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button no="1" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { EdiStatus } from '@/class/cargo/model/parameters/EdiStatus'

export default {
  name: 'AmsLogViewTitleDialog',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'dateCreated',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'createdBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Content'),
          field: 'content',
          width: 200,
          cellRenderer: params => {
            const data = params.data
            if (data.status) {
              const ediStatus = EdiStatus.getObjByStatus(data.status)
              return ediStatus ? ediStatus.chineseContent : ''
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'status',
          width: 100,
          cellRenderer: params => {
            const data = params.data
            if (data.status) {
              const ediStatus = EdiStatus.getObjByStatus(data.status)
              return ediStatus ? ediStatus.chineseLabel : ''
            }
            return ''
          }
        }
      ],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  }
}
</script>

<style>
</style>
